import { useQuery } from '@tanstack/react-query'
import { fetchCurrentElection, electionKeys } from '@/services/elections'

/**
 * Hook to fetch the upcoming/active election for a nation.
 * Returns the election that is scheduled, campaigning, or voting.
 */
export function useUpcomingElection(nationId: string | undefined) {
  const query = useQuery({
    queryKey: electionKeys.current(nationId!),
    queryFn: () => fetchCurrentElection(nationId!),
    enabled: !!nationId,
    refetchInterval: 30000,
    staleTime: 10000,
  })

  return {
    election: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
  }
}
